/**
 * Lazy load an image which is not rendered yet.
 * The `src` should match the `src` attribute of the image that
 * will be rendered later, including query params.
 *
 * Tip: use `setTimeout` to delay until after initial rendering is done,
 * else it does not improve much over inserting an `img` tag directly.
 */
export const preloadImg = (src: string) => {
  const img = new Image();

  img.src = src;
  img.decode();
};
